import * as Constants from '../Constants';

export async function resetPassword(auth) {
    // auth should be {email, password, totp}
    const api = Constants.BACKEND_URL + Constants.API_RESET_PASSWORD;
    return await fetch(api, {
        method: Constants.METHOD_POST,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: auth })
    });
}
